import React from "react";
import expiredIcon from "../../images/expired.svg";
import "./styles.scss";

const ExpiredLink = () => {
  return (
    <div className="expired-container">
      <img src={expiredIcon} alt="" />
      <p className="expired-message">Oops, that listing is not available</p>
    </div>
  );
};

export default ExpiredLink;
